import React, { useCallback, useRef } from "react";
import {
  Button,
  Col,
  Form,
  InputGroup,
  Modal,
  Row,
} from "@themesberg/react-bootstrap";
import { useCookies } from "react-cookie";
import Datetime from "react-datetime";
import moment from "moment-timezone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { addPeriods } from "../../../../../controller/api/gamePeriod";

export default (props) => {
  const [cookies] = useCookies(["lottmekong"]);

  const _onHide = () => {
    props.onHide();
  };

  const _name = useRef("");
  const _quantity = useRef(1);

  const _from = useRef();

  const _handleChangeFrom = useCallback((payload) => {
    _from.current = payload;
  }, []);

  const _handleChangeName = useCallback((payload) => {
    _name.current = payload.target.value;
  }, []);

  const _handleChangeQuantity = useCallback((payload) => {
    _quantity.current = parseInt(payload.target.value) || 1;
  }, []);

  const onSubmit = async () => {
    const periodName = _name.current;
    const dateStr = moment(_from.current).format("DD/MM/YYYY");
    const quantity = _quantity.current;

    console.log("=== Thêm kỳ Max3D ===");
    console.log("Tên kỳ:", periodName);
    console.log("Ngày:", dateStr);
    console.log("Số lượng:", quantity);

    const resp = await addPeriods(
      cookies.lottmekong,
      periodName,
      "max3d",
      dateStr,
      "18:30",
      quantity
    );
    if (resp) {
      console.log("Response:", resp);
      const message =
        `Kết quả thêm kỳ Max3D:\n\n` +
        `Tên kỳ bắt đầu: ${periodName}\n` +
        `Ngày: ${dateStr}\n` +
        `Số lượng yêu cầu: ${resp.totalRequested || quantity}\n` +
        `Số kỳ tạo thành công: ${resp.totalCreated || "N/A"}\n` +
        `Số kỳ bị skip (đã tồn tại): ${resp.totalSkipped || "N/A"}\n\n` +
        `Trang sẽ reload...`;
      alert(message);
      window.location.reload();
      _onHide();
    } else {
      alert("Có lỗi xảy ra");
      return false;
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={_onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Thêm kỳ quay Max3D
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row>
            <Col md={12} className="mb-2">
              <Form.Group id="firstName">
                <Form.Label>Tên kỳ</Form.Label>
                <Form.Control
                  required
                  type="number"
                  placeholder="Nhập tên kỳ"
                  onChange={_handleChangeName}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={12} className="mb-2">
              <Form.Label>Ngày</Form.Label>
              <Datetime
                timeFormat={false}
                onChange={_handleChangeFrom}
                renderInput={(props, openCalendar, closeCalendar) => (
                  <InputGroup>
                    <InputGroup.Text>
                      <FontAwesomeIcon icon={faCalendarAlt} />
                    </InputGroup.Text>
                    <Form.Control
                      required
                      type="text"
                      value={
                        _from.current
                          ? moment(_from.current).format("DD/MM/YYYY")
                          : ""
                      }
                      placeholder="dd/mm/yyyy"
                      onFocus={openCalendar}
                      onSubmit={closeCalendar}
                      onChange={() => {}}
                    />
                  </InputGroup>
                )}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12} className="mb-2">
              <Form.Group id="quantity">
                <Form.Label>Số lượng kỳ</Form.Label>
                <Form.Control
                  required
                  type="number"
                  min="1"
                  defaultValue="1"
                  placeholder="Nhập số lượng kỳ cần tạo"
                  onChange={_handleChangeQuantity}
                />
                <Form.Text className="text-muted">
                  Hệ thống sẽ tự động tạo các kỳ theo lịch: Thứ 2, Thứ 4, Thứ 6
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={_onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={onSubmit}>
          Thêm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
